module.exports = __webpack_public_path__ + "static/media/netto-keeping-track.952f4f35.png";